const TRIGGER_TYPE_TIME = 'time';
const TRIGGER_TYPE_SCROLL = 'scroll';
const TRIGGER_TYPE_EXIT_INTENT = 'exit';
import { BREAKPOINT_LG } from '../globals';

export default class Modal {

	static initAll() {
		const modalTriggers = document.querySelectorAll(`[data-modal-trigger]`);
		const modalsWithAutoTrigger = document.querySelectorAll('.modal[data-trigger-type="scroll"], .modal[data-trigger-type="time"], .modal[data-trigger-type="exit"]');
		const activeModals = document.querySelectorAll('.modal.active');

		// init all elements to trigger the modal
		modalTriggers.forEach((triggerElement) => {
			triggerElement.addEventListener('click', (e) => {
				e.preventDefault();
				let selector = triggerElement.getAttribute('data-modal-trigger');
				let modal = document.querySelector(selector);
				new Modal(modal).show();
			});
		});

		// init already active modals
		activeModals.forEach((modal) => new Modal(modal));

		// init modals that are triggered automatically
		modalsWithAutoTrigger.forEach((modal) => new Modal(modal));
	}

	constructor(modalElement) {
		if (!modalElement) {
			console.error('Can\'t init modal with an undefined or null modal element ');
			return;
		}

		this.initTime = new Date();
		this.element = modalElement;
		this.wrapper = this.element.querySelector('.modal__wrapper');
		this.panel = this.element.querySelector('.modal__panel');
		this.dismissers = this.element.querySelectorAll('[data-modal-dismiss="1"], [data-modal-dismiss="true"]');
		this.closeOnClickOutside = !!this.element.getAttribute('data-close-on-click-outside');
		this.triggerType = this.element.getAttribute('data-trigger-type');
		this.triggerWaitingPeriod = this.element.getAttribute('data-trigger-waiting-period');

		// close on click outside the modal, if enabled
		this.wrapper.addEventListener('click', (e) => {
			let isOutsideClick = !this.panel.contains(e.target);

			if (isOutsideClick && this.closeOnClickOutside)
				this.hide();
		});

		// close on click on an element having the data-modal-dismiss attribute
		this.dismissers.forEach((buttonDismiss) => {
			buttonDismiss.addEventListener('click', (e) => {
				e.preventDefault();
				this.hide()
			});
		});

		if (this.triggerType == TRIGGER_TYPE_TIME && this.triggerWaitingPeriod && !isNaN(this.triggerWaitingPeriod))
			this.triggerAfter(this.triggerWaitingPeriod);

		if (this.triggerType == TRIGGER_TYPE_SCROLL)
			this.triggerWhenVisible();

		if (this.triggerType == TRIGGER_TYPE_EXIT_INTENT)
			this.triggerWhenExitIntent();
	}

	isVisible() {
		return this.element.classList.contains('active');
	}

	async triggerAfter(seconds) {
		await this.pause(seconds * 1000);
		this.show();
		this.triggerExecuted = true;
	}

	async triggerWhenVisible() {
		await this.pause(this.triggerWaitingPeriod * 1000);

		let observer = new IntersectionObserver((entries) => {
			if (this.triggerExecuted || entries[0].isIntersecting !== true)
				return;

			this.show();
			this.triggerExecuted = true;
		});

		let popupPageModule = this.element.closest('.page__module');
		if (popupPageModule)
			observer.observe(popupPageModule);
	}

	async triggerWhenExitIntent() {
		// Only initialize exit intent on screens larger than LG breakpoint
		if (window.innerWidth <= BREAKPOINT_LG) {
			return;
		}

		function addEvent(obj, evt, fn) {
			if (obj.addEventListener) {
				obj.addEventListener(evt, fn, false);
			} else if (obj.attachEvent) {
				obj.attachEvent("on" + evt, fn);
			}
		}
		
		// Store reference to 'this' (the modal instance)
		const self = this;
		
		// Exit intent detection with vanilla JS
		addEvent(document, 'mouseout', function(evt) {
			// Only trigger if mouse leaves through the top of the window
			if (evt.toElement == null && evt.relatedTarget == null) {
				// Check if mouse is leaving through the top (y coordinate is 0 or negative)
				if (evt.clientY <= 0) {
					self.show();
					self.triggerExecuted = true;
				}
			}
		});
	}

	async show() {
		document.body.classList.add('modal-opened');
		this.wrapper.scrollTop = 0;

		this.element.classList.add('active');
		this.element.classList.add('entering');
		await this.pause(5);
		this.element.classList.replace('entering', 'entering-to');
		await this.pause(5);
		this.element.classList.remove('entering-to');
	}

	async hide() {
		this.element.classList.add('leaving');
		await this.pause(5);
		this.element.classList.replace('leaving', 'leaving-to');
		await this.pause(300);
		this.element.classList.remove('leaving-to', 'active');
		document.body.classList.remove('modal-opened');
	}

	async pause(ms) {
		ms ??= 1;
		let promise = new Promise((resolve) => {
			setTimeout(() => resolve(), ms);
		});
		await promise;
	}
}